<template>
  <div>
    <Head title="Logistics" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      Donasi Logistics
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset">
        <label class="block text-gray-700">Donatur:</label>
        <select v-model="form.donatur" class="form-select mt-1 w-full">
          <option :value="null">
            [ALL]
          </option>
          <option
            v-for="organization in organizations"
            :key="organization.id"
            :value="organization.id">
            {{ organization.name }}
          </option>
        </select>
        <label class="block text-gray-700 mt-5">User/Operator:</label>
        <select v-model="form.user" class="form-select mt-1 w-full">
          <option :value="null">
            [ALL]
          </option>
          <option
            v-for="user in users"
            :key="user.id"
            :value="user.id">
            {{ user.first_name + ' ' + user.last_name }}
          </option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/logistics/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Logistic</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Code
            </th>
            <th class="pb-4 pt-6 px-6">
              Donatur
            </th>
            <th class="pb-4 pt-6 px-6">
              Date
            </th>
            <th class="pb-4 pt-6 px-6">
              Description
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Operator
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="logistic in logistics.data"
            :key="logistic.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/logistics/${logistic.id}/edit`">
                {{ logistic.code }}
                <icon
                  v-if="logistic.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/logistics/${logistic.id}/edit`"
                tabindex="-1">
                {{ logistic.donatur }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/logistics/${logistic.id}/edit`"
                tabindex="-1">
                {{ logistic.trans_date }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/logistics/${logistic.id}/edit`">
                {{ logistic.description }}
                <icon
                  v-if="logistic.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/logistics/${logistic.id}/edit`">
                {{ logistic.operator }}
                <icon
                  v-if="logistic.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/logistics/${logistic.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="logistics.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">
              No logistics found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="logistics.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        logistics: Object,
        organizations: Object,
        users: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                donatur: this.filters.donatur,
                user: this.filters.user,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/logistics', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
